import { Dialog } from 'evergreen-ui';
import EditCollaboratorForm from './EditCollaboratorForm';

const EditCollaboratorDialog = ({
    isShown,
    onClose,
    collaborator,
    fetchCollaborators
}) => {
    return (
        <Dialog
            isShown={isShown}
            title="Modifica collaboratore"
            onCloseComplete={onClose}
            hasFooter={false}
        >
            {collaborator && (
                <EditCollaboratorForm
                    editedCollaborator={collaborator}
                    handleCancelEdit={onClose}
                    fetchCollaborators={fetchCollaborators}
                />
            )}
        </Dialog>
    );
};

export default EditCollaboratorDialog;